import { AlertTriangle } from "lucide-react";
import { useMemo } from "react";

import { mapProviderToDisplayName } from "../ProviderDropdown/utils";
import { BasicTooltip } from "../ui/Tooltip";
import { OverflowDisplayTooltip } from "../ui/Tooltip/OverflowDisplayTooltip";

import { ProviderIcon } from "./ProviderIcon";
import { ProviderWithLogoProps } from "./types";

export { ProviderIcon } from "./ProviderIcon";

export const ProviderWithLogo = ({
  provider,
  filter,
  hideName = false,
  size,
  className,
}: ProviderWithLogoProps) => {
  const displayName = useMemo(() => mapProviderToDisplayName(provider || ""), [provider]);

  const iconSize = size === "sm" ? "h-3 w-3" : "h-4 w-4";
  const marginRight = size === "sm" ? "mr-1.5" : "mr-2";
  const textSize = size === "sm" ? "text-xs" : "text-sm";

  return (
    <div className="flex min-w-0 items-center">
      <div
        className={`${marginRight} flex ${iconSize} flex-shrink-0 items-center justify-center ${className}`}
      >
        <ProviderIcon provider={provider || ""} className={iconSize} filter={filter} />
      </div>
      {!hideName && (
        <OverflowDisplayTooltip
          content={displayName}
          shouldShow={Boolean(displayName)}
          className={`min-w-0 max-w-full ${textSize}`}
        >
          {displayName}
        </OverflowDisplayTooltip>
      )}
      {provider === "anthropic.bedrock" && (
        <BasicTooltip
          content="This provider is no longer supported. We recommend switching to Amazon Bedrock for access to all Bedrock models in one place."
          side="top"
          variant="black"
        >
          <span className="ml-2 inline-flex cursor-help items-center rounded-full bg-orange-100 px-2 py-0.5 text-xs font-medium text-orange-800">
            <AlertTriangle className="mr-1 h-3 w-3" />
            Deprecated
          </span>
        </BasicTooltip>
      )}
    </div>
  );
};
